import { RuleCondition } from './RuleCondition'
import type { FieldsResponse, PredicateNode } from './types'

export function RuleGroup({
  metadata, node, onChange, onDelete,
}: {
  metadata: FieldsResponse
  node: Extract<PredicateNode, { type: 'group' }>
  onChange: (next: PredicateNode) => void
  onDelete?: () => void
}) {
  const setChild = (idx: number, child: PredicateNode) => {
    const children = [...node.children]
    children[idx] = child
    onChange({ ...node, children })
  }
  const removeChild = (idx: number) => {
    const children = node.children.filter((_, i) => i !== idx)
    if (children.length === 0) {
      onDelete?.()
      return
    }
    onChange({ ...node, children })
  }
  const addCondition = () => {
    const f = metadata.fields[0]
    if (!f) return
    const newChild: PredicateNode = { type: 'condition', field: f.path, op: '==', value: null }
    onChange({ ...node, children: [...node.children, newChild] })
  }
  const addGroup = () => {
    const f = metadata.fields[0]
    if (!f) return
    const inner: PredicateNode = { type: 'condition', field: f.path, op: '==', value: null }
    const newChild: PredicateNode = { type: 'group', connector: 'and', children: [inner] }
    onChange({ ...node, children: [...node.children, newChild] })
  }
  const flipConnector = () => {
    onChange({ ...node, connector: node.connector === 'and' ? 'or' : 'and' })
  }

  return (
    <div className="border-l-2 border-slate-300 pl-3 my-1.5">
      <div className="flex items-center gap-2 mb-1">
        <button
          type="button"
          onClick={flipConnector}
          className={`text-[11px] uppercase font-medium px-2 py-0.5 rounded ${
            node.connector === 'and'
              ? 'bg-blue-100 text-blue-700 border border-blue-300'
              : 'bg-orange-100 text-orange-700 border border-orange-300'
          }`}
          title="Przełącz I / LUB"
        >{node.connector === 'and' ? 'I' : 'LUB'}</button>
        {onDelete && (
          <button
            type="button"
            onClick={onDelete}
            className="text-xs text-red-600 hover:text-red-800 px-1"
            title="Usuń grupę"
          >× grupa</button>
        )}
      </div>

      {node.children.map((child, idx) => {
        if (child.type === 'group') {
          return (
            <RuleGroup
              key={idx}
              metadata={metadata}
              node={child}
              onChange={c => setChild(idx, c)}
              onDelete={() => removeChild(idx)}
            />
          )
        }
        if (child.type === 'condition') {
          return (
            <RuleCondition
              key={idx}
              metadata={metadata}
              node={child}
              onChange={c => setChild(idx, c)}
              onDelete={() => removeChild(idx)}
            />
          )
        }
        return null
      })}

      <div className="flex gap-2 mt-1">
        <button
          type="button"
          onClick={addCondition}
          className="text-xs text-sky-700 hover:text-sky-900"
        >+ warunek</button>
        <button
          type="button"
          onClick={addGroup}
          className="text-xs text-violet-700 hover:text-violet-900"
        >+ grupa</button>
      </div>
    </div>
  )
}
